<script>
    import axios from 'axios'

    import { Container, ScrollAnchor, DemoButton } from '@/components'

    let showSuccess
    let showError
    let showErrorName
    let showErrorEmail

    const handleSubmit = (event) => {
        event.preventDefault()
        
        showSuccess = false
        showError = false
        showErrorName = false
        showErrorEmail = false

        const formData = new FormData(event.target)
        if (formData.get('name')==null || formData.get('name')==""){ 
            showErrorName = true
            document.querySelector("input[name=name]").classList.add("error");
            
        }
        if (formData.get('email')==null || formData.get('email')==""){ 
            showErrorEmail = true
            
        }
        if (showErrorEmail || showErrorName){
            return false
        }
        console.log('name')
        console.log(formData.get('name'))

        console.log(formData.get('company'))
        console.log(formData.get('email'))

        axios.post('./mail.php', formData)
        .then((response) => {
            showSuccess = true
            ym(88256496,'reachGoal','demo_form')
            
        })
        .catch((err) => {
            console.log(err)
            showError = true
        })
    }

    function handleClickPhone() {
		ym(88256496,'reachGoal','phone_click')
	}
    function handleClickMail() {
		ym(88256496,'reachGoal','email_click')
	}
</script>

<Container>
    <ScrollAnchor id="contacts" />
    <h2 class="title">Личный кабинет EmployeeGate делает работу<br/> удобной и прозрачной. Прямо как наше<br/> будущее сотрудничество</h2>

    <div class="description">Оставьте контакты, мы с вами свяжемся и рассчитаем стоимость внедрения под вашу<br/> компанию или позвоните для консультации. </div>
    <!-- <div class="description">Пишите, чтобы получить демо-версию</div> -->

    <div class="background" slot="background" />

    <form on:submit={handleSubmit}>
        
        {#if showErrorName}
        <div class="error-text form">Поле Имя не может быть пустым</div>
        {/if}
        <input name="name" placeholder="Имя" />
        <input name="company" placeholder="Компания" />
        <input type="email" name="email" placeholder="Email" />
        {#if showErrorEmail}
            <div class="error-text form">Поле Email не может быть пустым</div>
        {/if}

        {#if showSuccess}
            <div class="success-text">Данные успешно отправлены</div>
        {/if}

        {#if showError}
            <div class="error-text">Произошла ошибка отправки формы</div>
        {/if}

        <div class="button-wrapper">
            <DemoButton withoutScroll />
        </div>
    </form>

    <div class="contacts"><a class="phone" on:click={handleClickPhone} on:contextmenu|once={handleClickPhone} href="tel:+74992168063">+7 (499) 216-80-63</a><br/>
        <a class="mail" on:click={handleClickMail} on:contextmenu|once={handleClickMail} href="mailto:info.ru@ucmsgroup.ru">info.ru@ucmsgroup.ru</a></div>
</Container>

<style lang="scss">
    .title {
        margin-top: 100px;
        color: #ffffff;
        line-height: 60px;
        text-align: center;
    }

    .description {
        margin-top: 40px;
        line-height: 25px;
        text-align: center;
        color: #ffffff;
    }

    form {
        margin-top: 90px;

        input {
            margin: 0 auto;
            display: block;
            width: 594px;
            height: 60px;
            box-shadow: 5px 4px 32px rgba(0, 0, 0, 0.25);
            background-color: rgba(255, 255, 255, 0.46);
            border: 0;
            outline: none;
            font-size: 18px;
            line-height: 23px;
            padding-left: 34px;
            padding-right: 34px;
            color: #ffffff;

            &[name=name] {
                border-radius: 0 16px 16px 16px;
            }

            &[name=company] {
                border-radius: 16px 16px 0 16px;
            }

            &[name=email] {
                border-radius: 16px 16px 16px 0;
            }
        }

        input + input {
            margin-top: 30px;
        }

        .success-text,
        .error-text {
            color: #fff;
            margin-top: 30px;
            text-align: center;
            
        }

        .error-text {
            color: #EA5B0C;
        }
        .error-text.form {
            margin-top: 10px;
            margin-bottom: 10px;
            color: #EA5B0C;
            font-weight: bold;  
        }

 



        .button-wrapper {
            display: flex;
            justify-content: center;
            margin-top: 60px;
        }

        input::-webkit-input-placeholder {
            color: #d7e6fc;
        }

        ::-moz-placeholder {
            color: #d7e6fc;
        }

        :-ms-input-placeholder {
            color: #d7e6fc;
        }

        ::-webkit-input-placeholder {
            color: #d7e6fc;
        }

        ::placeholder {
            color: #d7e6fc;
        }
    }

    .contacts {
	font-weight: 700;
	font-size: 24px;
	line-height: 30px;
	text-align: center;
	margin-top: 80px;
	margin-bottom: 74px;
	color: #ffffff;
	.mail {
		color: #ffffff;
        text-decoration:none;
	}
	.phone {
		color: #ffffff;
        text-decoration:none;
	}
    .phone:hover {
        text-decoration:underline;
	}
    .mail:hover {
        text-decoration:underline;
	}
}
    .background {
        position: absolute;
        top: 0;
        left: 0;
        z-index: -1;
        width: 100%;
        height: 100%;
        background-image: url('../img/form-background.jpg');
        background-repeat: no-repeat;
        background-size: cover;
    }

    @media (max-width: 834px) {
        .title,
        .description {
            br {
                display: none;
            }
        }
    }

    @media (max-width: 420px) {
        form {
            margin-top: 50px;

            input {
                width: 100%;
            }
        }
    }

</style>